import { useTranslation } from 'react-i18next';
import routes from '@root/routes';
import V2Button from '@components/shared/V2Button';
import s from './ResultsEmptyState.module.less';

// clearFilters = () => {
//   console.log(':)')
// };

const EmptyState = () => {
  const { t } = useTranslation('listingSearch');

  return (
    <>
      <div className={s.emptyState}>{t('emptyState')}</div>
      <a href={routes.listingSearch()}>
        <V2Button type="secondary" size="large">
          {t('removeFilters')}
        </V2Button>
      </a>
    </>
  );
};

export default EmptyState;
